<template>
  <div
    :class="['card', { 'inactive': card.isInactive }, card.className]"
    @mouseenter="showHovered"
    @mouseleave="hideHovered"
    @click="openModal"
  >
    <div :class="['card__plus', card.className]">
      <img
        v-if="!hovered"
        src="/v2/ege/schedule/plus.svg"
        alt="plus"
      >
      <img
        v-else
        src="/v2/ege/schedule/minus.svg"
        alt="minus"
      >
    </div>

    <div :class="['card__time', card.className]">
      {{ card.time }}
    </div>

    <div class="card__label">
      {{ card.label }}
    </div>

    <div
      v-if="!hovered"
      class="card__tutor"
    >
      <img
        v-if="card.tutorPhoto"
        :src="card.tutorPhoto"
        :alt="card.tutor"
      >
      <span>
        {{ card.tutor }}
      </span>
    </div>

    <button
      v-if="hovered && !card.link"
      :class="['card__button', card.className]"
      @click="$emit('openModal', 'demo')"
    >
      Получить демо-доступ
    </button>
    <nuxt-link
      v-if="hovered && card.link"
      :to="card.link"
      :class="['card__button', card.className]"
    >
      {{ card.linkText }}
    </nuxt-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EgeScheduleCard',
  props: {
    card: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    hovered: false,
  }),
  computed: {
    ...mapGetters({
      isTablet: 'isTablet',
    }),
  },
  methods: {
    showHovered() {
      if (!this.isTablet) {
        this.hovered = true;
      }
    },
    hideHovered() {
      if (!this.isTablet) {
        this.hovered = false;
      }
    },
    openModal() {
      if (this.isTablet) {
        if (!this.card.link) {
          this.$emit('openModal', 'demo');
        } else {
          this.$router.push(this.card.link);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: 143px;
  padding: 20px;
  position: relative;
  overflow: hidden;

  border-radius: 20px;
  background-color: $gray-bg;
  box-shadow: 2px 2px 10px 0 rgba($ege-gray-blue, 0.02) inset, 8px 8px 30px 0 rgba($ege-gray-blue, 0.02) inset;

  transition: filter .2s ease-out;

  @include media-down(tablet) {
    height: 111px;
    padding: 16px;
  }

  &:before {
    content: '';
    display: block;
    width: 166.737px;
    height: 339px;
    position: absolute;
    left: 90px;
    top: 100px;
    transform: rotate(-103.045deg);
    border-radius: 339px;
    background-color: #61DDBC;
    filter: blur(60px);
  }

  &__plus {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;

    border-radius: 50px;
    border: 2px solid $black-color;
    background-color: $header-dark-orange;
    box-shadow: 1px 1px 0 0 $black-color;

    @include media-down(tablet) {
      top: 12px;
      right: 12px;
    }
  }
  &__plus.math {
    background-color: $header-dark-orange;
  }
  &__plus.istoriya {
    background-color: $blue-dark;
  }
  &__plus.anglijskij-yazyk {
    background-color: $ege-red;
  }
  &__plus.informatika {
    background-color: #F5B945;
  }
  &__plus.himiya {
    background-color: $violet;
  }
  &__plus.russkij-yazyk {
    background-color: $ege-red;
  }
  &__plus.fizika {
    background-color: #35BA9B;
  }
  &__plus.biologiya {
    background-color: #89C053;
  }
  &__plus.obshchestvoznanie {
    background-color: #3AADD9;
  }
  &__plus.literatura {
    background-color: #E3B692;
  }

  &__time {
    font-variant-numeric: lining-nums proportional-nums;
    font-feature-settings: 'case' on;
    font-size: 14px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.28px;
  }
  &__time.math {
    color: $header-dark-orange;
  }
  &__time.istoriya {
    color: $blue-dark;
  }
  &__time.anglijskij-yazyk {
    color: $ege-red;
  }
  &__time.informatika {
    color: #F5B945;
  }
  &__time.himiya {
    color: $violet;
  }
  &__time.russkij-yazyk {
    color: $ege-red;
  }
  &__time.fizika {
    color: #35BA9B;
  }
  &__time.biologiya {
    color: #89C053;
  }
  &__time.obshchestvoznanie {
    color: #3AADD9;
  }
  &__time.literatura {
    color: #E3B692;
  }

  &__label {
    margin-top: 4px;

    font-variant-numeric: lining-nums proportional-nums;
    font-size: 22px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.22px;
    text-transform: uppercase;
    color: $black-color;

    @include media-down(tablet) {
      font-size: 18px;
      letter-spacing: -0.18px;
    }
  }

  &__tutor {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 20px;

    font-variant-numeric: lining-nums proportional-nums;
    font-size: 20px;
    font-weight: 500;
    line-height: 130%;
    letter-spacing: -0.2px;
    color: $black-color;

    @include media-down(tablet) {
      margin-top: 12px;

      font-size: 16px;
      font-weight: 600;
      line-height: 120%;
      letter-spacing: normal;
    }

    img {
      width: 40px;
      height: 40px;

      @include media-down(tablet) {
        width: 28px;
        height: 28px;
      }
    }
  }

  &__button {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;

    border: none;
    border-radius: 50px;
    background-color: #999999;

    font-variant-numeric: lining-nums proportional-nums;
    font-size: 16px;
    font-weight: 700;
    line-height: 100%;
    color: $black-color;

    cursor: pointer;

    @include media-down(tablet) {
      height: 34px;
      margin-top: 12px;
    }
  }
  &__button.math {
    background-color: #FB836F;
  }
  &__button.istoriya {
    background-color: #73B0F4;
  }
  &__button.anglijskij-yazyk {
    background-color: #F76C82;
  }
  &__button.informatika {
    background-color: #FBD277;
  }
  &__button.himiya {
    background-color: $violet;
  }
  &__button.russkij-yazyk {
    background-color: #F76C82;
  }
  &__button.fizika {
    background-color: #61DDBC;
  }
  &__button.biologiya {
    background-color: #B4DF80;
  }
  &__button.obshchestvoznanie {
    background-color: #9FE3FF;
  }
  &__button.literatura {
    background-color: #F4D0B5;
  }
}

.card.math:before {
  background-color: #FB836F;
}
.card.istoriya:before {
  background-color: #67ADFF;
}
.card.anglijskij-yazyk:before {
  background-color: #F76C82;
}
.card.informatika:before {
  background-color: #FBD277;
}
.card.himiya:before {
  background-color: $violet;
}
.card.russkij-yazyk:before {
  background-color: #F76C82;
}
.card.fizika:before {
  background-color: #61DDBC;
}
.card.biologiya:before {
  background-color: #B4DF80;
}
.card.obshchestvoznanie:before {
  background-color: #9FE3FF;
}
.card.literatura:before {
  background-color: #F4D0B5;
}

.card.inactive {
  pointer-events: none;
  filter: blur(4px);
}
</style>
